<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<div class="base_inquire" style="height: 36px;">
				<div class="b_item" style="margin: 0;">
					<span class="b_label">所属分类：</span>
					<el-select v-model="search_primary" class="b_inp" @change="handleSearchChange">
						<el-option :value="0" label="全部"></el-option>
						<el-option v-for="v in primary_list" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<el-button type="primary" style="float: right;" @click="handleAddClick">新增</el-button>
			</div>
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="名称"
					>
					</el-table-column>
					<el-table-column
						prop="parentName"
						label="所属分类"
					>
					</el-table-column>
					<el-table-column
						prop="showTypeName"
						label="显示类型"
					>
					</el-table-column>
					<el-table-column
						label="图片"
					>
						<template slot-scope="scope">
							<img :src="scope.row.picUrl" alt="" style="width: 48px;">
						</template>
					</el-table-column>
					<el-table-column
						prop="productName"
						label="对应产品"
					>
					</el-table-column>
					<el-table-column
						prop="url"
						label="链接"
						width="300"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="200"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增弹框 -->
		<Popup 
			v-model="add_display"
			title="新增二级分类"
			confirmBtnText="添加"
			@confirmClick="handleAddPopupConfirmClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>名称</span>
					<el-input v-model="add_name" placeholder="名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addName_tip"><i class="b_icon"></i>请输入名称</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>所属分类</span>
					<el-select v-model="add_primary" style="width: 100%;">
						<el-option v-for="v in primary_list" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>显示类型</span>
					<el-select v-model="add_show_type" style="width: 100%;">
						<el-option :value="1" label="网页链接"></el-option>
						<el-option :value="2" label="二维码"></el-option>
					</el-select>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>上传图片</span>
					<div v-if="!add_pic_url" class="b_upload b_inline_block">
						<el-button type="primary">点击上传</el-button>
						<input type="file" accept="image/*" @change="handleAddUpload"/>
						<span class="b_upload_tip">请上传jpg或者png图片！！！</span>
					</div>
					<div v-if="add_pic_url" class="b_upload b_inline_block" style="border: 1px solid #ccc;">
						<img :src="add_pic_url" alt="" style="">
						<i @click="handleAddUploadDelete"></i>
					</div>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addPic_tip"><i class="b_icon"></i>请上传图片</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>对应产品</span>
					<el-select v-model="add_product" style="width: 100%;">
						<el-option v-for="v in authProduct" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>链接</span>
					<el-input v-model="add_url" placeholder="链接"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addUrl_tip"><i class="b_icon"></i>链接格式不合法</template></div>
			</div>
		</Popup>
		<!-- 新增弹框 end -->
		
		<!-- 修改弹框 -->
		<Popup 
			v-model="update_display"
			title="修改二级分类"
			confirmBtnText="确定"
			@confirmClick="handleUpdatePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>名称</span>
					<el-input v-model="update_name" placeholder="名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateName_tip"><i class="b_icon"></i>请输入名称</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>所属分类</span>
					<el-select v-model="update_primary" style="width: 100%;">
						<el-option v-for="v in primary_list" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>显示类型</span>
					<el-select v-model="update_show_type" style="width: 100%;">
						<el-option :value="1" label="网页链接"></el-option>
						<el-option :value="2" label="二维码"></el-option>
					</el-select>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>上传图片</span>
					<div v-if="!update_pic_url" class="b_upload b_inline_block">
						<el-button type="primary">点击上传</el-button>
						<input type="file" accept="image/*" @change="handleUpdateUpload"/>
						<span class="b_upload_tip">请上传jpg或者png图片！！！</span>
					</div>
					<div v-if="update_pic_url" class="b_upload b_inline_block" style="border: 1px solid #ccc;">
						<img :src="update_pic_url" alt="" style="">
						<i @click="handleUpdateUploadDelete"></i>
					</div>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updatePic_tip"><i class="b_icon"></i>请上传图片</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>对应产品</span>
					<el-select v-model="update_product" style="width: 100%;">
						<el-option v-for="v in authProduct" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>链接</span>
					<el-input v-model="update_url" placeholder="链接"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateUrl_tip"><i class="b_icon"></i>链接格式不合法</template></div>
			</div>
		</Popup>
		<!-- 修改弹框 end -->
		
		<!-- 删除弹出框 -->
		<Popup
			v-model="delete_display"
			title="提示"
			@confirmClick="handleDeletePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<p style="color: #5f6468;line-height: 24px;">您确认要删除该条吗？</p>
			</div>
		</Popup>
		<!-- 删除弹出框 end -->
	</div>
</template>

<script>
	import Api from '../../../../../api/index.js'
	import BaseMethods from '../../../../../assets/js/base.js'
	import { mapState } from 'vuex'
	
	export default {
		mounted () {
			this.getPrimary();
		},
		data () {
			return {
				loading: false,
				
				primary_list: [],
				search_primary: 0,
				tableData: [],
				currentPage: 1,
				total: 0,
				
				add_display: false,
				add_name: '',
				add_primary: '',
				add_show_type: 1,
				add_pic_url: '',
				add_pic_name: '',
				add_product: '',
				add_url: '',
				addName_tip: false,
				addPic_tip: false,
				addUrl_tip: false,
				
				update_display: false,
				update_id: '',
				update_name: '',
				update_primary: '',
				update_show_type: 1,
				update_pic_url: '',
				update_pic_name: '',
				update_product: '',
				update_url: '',
				updateName_tip: false,
				updatePic_tip: false,
				updateUrl_tip: false,
				
				delete_display: false,
				delete_id: ''
			}
		},
		computed: {
			...mapState(['safeInfo', 'authProduct'])
		},
		methods: {
			/*********************** @Events ***********************/
			// 搜索框change
			handleSearchChange () {
				this.currentPage = 1;
				this.getSecondary();
			},
			
			// 点击新增
			handleAddClick () {
				this.add_name = '';
				this.add_primary = this.primary_list[0] ? this.primary_list[0].id : '';
				this.add_show_type = 1;
				this.add_pic_url = '';
				this.add_pic_name = '';
				this.add_product = this.authProduct[0] ? this.authProduct[0].id : '';
				this.add_url = '';
				this.addName_tip = false;
				this.addPic_tip = false;
				this.addUrl_tip = false;
				this.add_display = true;
			},
			// 上传图片
			handleAddUpload (e) {
				const that = this;
				BaseMethods.uploadMultiImg(e, (base64, imgs_type, imgs_name) => {
					that.uploadPic(base64[0], imgs_type[0], imgs_name[0], 'add');
				}, (msg) => {
					that.$message.error(msg);
				});
			},
			// 删除上传的图片
			handleAddUploadDelete () {
				this.add_pic_url = '';
				this.add_pic_name = '';
			},
			// 点击新增弹框确定按钮
			handleAddPopupConfirmClick () {
				if (!this.add_name.trim()) {
					this.addName_tip = true;
					return false;
				} else {
					this.addName_tip = false;
				}
				if (!this.add_pic_url) {
					this.addPic_tip = true;
					return false;
				} else {
					this.addPic_tip = false;
				}
				if (!this.urlReg.test(this.add_url)) {
					this.addUrl_tip = true;
					return false;
				} else {
					this.addUrl_tip = false;
				}
				this.addSecondary();
			},
			
			// 点击修改
			handleUpdateClick (obj) {
				this.update_id = obj.id;
				this.update_name = obj.name;
				this.update_primary = obj.parentId 
					? obj.parentId 
					: this.primary_list[0] ? this.primary_list[0].id : '';
				this.update_show_type = obj.showType ? obj.showType : 1;
				this.update_pic_url = obj.picUrl;
				this.update_pic_name = obj.picName;
				this.update_product = obj.productId 
					? obj.productId 
					: this.authProduct[0] ? this.authProduct[0].id : '';
				this.update_url = obj.url;
				this.updateName_tip = false;
				this.updatePic_tip = false;
				this.updateUrl_tip = false;
				this.update_display = true;
			},
			// 上传图片
			handleUpdateUpload (e) {
				const that = this;
				BaseMethods.uploadMultiImg(e, (base64, imgs_type, imgs_name) => {
					that.uploadPic(base64[0], imgs_type[0], imgs_name[0], 'update');
				}, (msg) => {
					that.$message.error(msg);
				})
			},
			// 删除上传的图片
			handleUpdateUploadDelete () {
				this.update_pic_url = '';
				this.update_pic_name = '';
			},
			// 点击修改弹框确定按钮
			handleUpdatePopupConfirmClick () {
				const that = this;
				if (!this.update_name.trim()) {
					this.updateName_tip = true;
					return false;
				} else {
					this.updateName_tip = false;
				}
				if (!this.update_pic_url) {
					this.updatePic_tip = true;
					return false;
				} else {
					this.updatePic_tip = false;
				}
				if (!this.urlReg.test(this.update_url)) {
					this.updateUrl_tip = true;
					return false;
				} else {
					this.updateUrl_tip = false;
				}
				that.$confirm(
					'此操作将修改该二级分类?', 
					'提示', 
					{
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.updateSecondary();
					}
				);
			},
			
			// 点击删除
			handleDeleteClick (obj) {
				this.delete_id = obj.id;
				this.delete_display = true;
			},
			// 点击删除弹框确定按钮
			handleDeletePopupConfirmClick () {
				const that = this;
				that.loading = true;
				var requestData = {
					id: that.delete_id
				};
				Api.deleteWebSecondary(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.delete_display = false;
						that.$message.success(res.data.message);
						that.currentPage = 1;
						that.getSecondary();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			
			// 改变页码
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getSecondary();
				}
			},
			
			/*********************** @Function ***********************/
			// 获取一级分类
			getPrimary () {
				const that = this;
				that.loading = true;
				var requestData = {
					limit: 0,
					pageNum: 0
				};
				Api.findWebPrimary(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						for (var i = 0;i < res.data.data.length;i++) {
							var _o = res.data.data[i];
							that.primary_list.push({
								id: _o.id,
								name: _o.typeName
							});
						}
						that.getSecondary();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取二级分类
			getSecondary () {
				const that = this;
				that.loading = true;
				var requestData = {
					fuId: that.search_primary,
					limit: 10,
					pageNum: that.currentPage
				};
				Api.findWebSecondary(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.tableData = [];
						for (var i = 0;i < res.data.data.data.length;i++) {
							var _o = res.data.data.data[i];
							that.tableData.push({
								id: _o.id,
								parentId: _o.parentId,
								name: _o.title || '',
								parentName: _o.parentTypeName || '',
								picUrl: _o.picUrl || '',
								picName: _o.picName || '',
								productId: _o.productId,
								productName: that.mapProductIdToName(_o.productId),
								showType: _o.showType || 1,
								showTypeName: that.mapShowTypeIdToName(_o.showType),
								url: _o.webUrl || ''
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 上传图片
			uploadPic (base64, img_type, fileName, type) {
				const that = this;
				that.loading = true;
				var pic_name = '';
				if (type == 'add') {
					that.add_pic_name = `${ new Date().getTime() }_${ fileName }`;
					pic_name = that.add_pic_name;
				} else {
					that.update_pic_name = `${ new Date().getTime() }_${ fileName }`;
					pic_name = that.update_pic_name;
				}
				var requestData = {
					base: base64,
					picName: pic_name,
					type: 'uGateWayUrl'
				};
				Api.uploadPic(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						type == 'add' 
							? (that.add_pic_url = res.data.data.imgUrl)
							: (that.update_pic_url = res.data.data.imgUrl);
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 新增二级分类
			addSecondary () {
				const that = this;
				that.loading = true;
				var requestData = {
					createTime: null,
					dr: null,
					explain: null,
					id: null,
					parentId: that.add_primary,
					parentTypeName: null,
					picName: that.add_pic_name,
					picUrl: that.add_pic_url,
					positions: null,
					productId: that.add_product,
					showType: that.add_show_type,
					title: that.add_name,
					typeName: null,
					webUrl: that.add_url
				};
				Api.addWebSecondary(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.add_display = false;
						that.$message.success(res.data.message);
						that.getSecondary();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 修改二级分类
			updateSecondary () {
				const that = this;
				that.loading = true;
				var requestData = {
					createTime: null,
					dr: null,
					explain: null,
					id: that.update_id,
					parentId: that.update_primary,
					parentTypeName: null,
					picName: that.update_pic_name,
					picUrl: that.update_pic_url,
					positions: null,
					productId: that.update_product,
					showType: that.update_show_type,
					title: that.update_name,
					typeName: null,
					webUrl: that.update_url
				};
				Api.updateWebSecondary(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.update_display = false;
						that.$message.success(res.data.message);
						that.getSecondary();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 根据产品ID转换对应的名称
			mapProductIdToName (productId) {
				var name = '';
				for (var i = 0;i < this.authProduct.length;i++) {
					this.authProduct[i].id == productId
						&& (name = this.authProduct[i].name);
				}
				return name;
			},
			// 根据产品showtype转换对应的名称
			mapShowTypeIdToName (showType) {
				var name = '';
				switch (showType) {
					case 0:
						name = '功能暂未开发';
						break;
					case 1:
						name = '网页链接';
						break;
					case 2:
						name = '二维码';
						break;
				}
				return name;
			}
		}
	}
</script>

<style scoped>
	.back_tools_manage{ position: relative;width: 100%;height: 100%;padding: 15px; }
	.back_tools_manage .scroller{ width: 100%;height: 100%;padding: 15px;background: #fff;overflow-x: hidden;overflow-y: auto; }
</style>
